<div class='delivery-overview-tab-2-part'>
	This is tab 2
</div>